export enum FormTypeEnum {
  PIB = 'pib',
  USD = 'usd',
  ACTIONS = 'actions'
}